import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import type { BatchPoint } from "../batches"
import { AXIS_TICK, ActionKey, PointTooltip, actionMarkers } from "./chartParts"

// How many units of this batch were left, week by week since it joined the
// push list. Numbered circles mark past actions, so a steeper drop after one
// shows it helped.
export default function BatchChart({ points }: { points: BatchPoint[] }) {
  const every = points.length > 30 ? 8 : 4

  return (
    <div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={points} margin={{ top: 24, right: 24, bottom: 0, left: 0 }}>
          <CartesianGrid stroke="var(--chart-grid)" vertical={false} />
          <XAxis
            dataKey="i"
            type="number"
            domain={[0, points.length - 1]}
            ticks={points.filter((p) => p.i % every === 0).map((p) => p.i)}
            tickFormatter={(i: number) => points[i]?.tick ?? ""}
            tick={AXIS_TICK}
            stroke="var(--chart-grid)"
            interval={0}
          />
          <YAxis width={44} tick={AXIS_TICK} stroke="var(--chart-grid)" domain={[0, "auto"]} />
          <Tooltip
            content={<PointTooltip lines={(p: BatchPoint) => [`Left: ${p.qty.toLocaleString()}`]} />}
            cursor={{ stroke: "var(--chart-axis)", strokeWidth: 1 }}
          />
          {actionMarkers(points)}
          <Line
            dataKey="qty"
            stroke="var(--series-1)"
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 5, strokeWidth: 2, stroke: "var(--card)" }}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
      <ActionKey actions={points.flatMap((p) => p.actions)} />
    </div>
  )
}
